<template>
  <div>
    <vs-breadcrumb class="mb-6" :items="
   [
     {
       title: '营销中心',
       url: '/sales/recommend'
     },
     {
       title: '栏目推荐',
       active: true
     }
   ]"></vs-breadcrumb>
    <div>
      <vs-table ref="table" :max-items="itemsPerPage" :data="list" :noDataText="noDataText" :stripe="true">
        <template slot="thead">
          <vs-th width="8%">操作</vs-th>
          <vs-th width="15%">推荐分类<br />推荐主标题<br />推荐子标题<br /></vs-th>
          <vs-th width="10%">封面图片<br />尺寸类型<br />(4:3 or 1.1)</vs-th>
          <vs-th>推荐商品列表</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <template v-for="(tr, index) in data">
              <vs-tr :key="index">
                <vs-td>
                  <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current a-hover"
                    @click.stop="editData(tr, index)" />
                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current a-hover"
                    class="ml-2" @click.stop="deleteData(tr.id, tr.name, index)" />
                </vs-td>
                <vs-td>
                  {{tr.category_id === 0?'首页推荐':''}}<br /><br />

                  <ul class="con-s">
                    <li>
                      <div class="mb-1">{{Number(tr.status) === 1?'可用':'已禁用'}}</div>
                      <vs-switch v-model="tr.status" @input="changeSwitch(tr)" />
                    </li>
                  </ul>
                  <br />
                  <span class="_800">{{tr.name}}</span><br /><span class="text-muted">{{tr.sub_title}}</span>

                  <!-- <br />
                  {{tr.status === 1?'可用':'已禁用'}} -->
                </vs-td>
                <vs-td>{{tr.type===1?'竖向4:3':'1:1'}}</vs-td>
                <vs-td>

                  <vs-table :noDataText="noDataText">
                    <template slot="thead">
                      <vs-th width="10%">推荐封面</vs-th>
                      <vs-th width="20%">
                        商品名称
                      </vs-th>
                      <vs-th width="12%">是否团购</vs-th>
                      <vs-th width="12%">市场价</vs-th>
                      <vs-th width="12%">零售价</vs-th>
                      <vs-th width="12%">团购价</vs-th>
                    </template>
                    <template>
                      <vs-tr v-for="sub in tr.items" :key="sub.id">
                        <vs-td>
                          <img :src="sub.image" class="w-full" />
                        </vs-td>
                        <vs-td>
                          {{sub.name}}
                        </vs-td>
                        <vs-td>{{sub.group_type === 1?'':'团购'}}</vs-td>
                        <vs-td>
                          {{sub.goods.market_price}}
                        </vs-td>
                        <vs-td>
                          {{sub.goods.price}}
                        </vs-td>
                        <vs-td>
                          {{sub.goods.group_price}}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </vs-td>
              </vs-tr>
            </template>
          </tbody>
        </template>
      </vs-table>

    </div>
  </div>
</template>
<script>
  import recommendRepo from '@/repo/recommend'
  export default {
    data() {
      return {
        list: [],
        itemsPerPage: 20,
        noDataText: '',
        categoryId: 0
      }
    },
    mounted() {
      this.getRecommentTopList()
    },

    methods: {
      getRecommentTopList: function () {
        recommendRepo.topList((error, data) => {
          console.log(error)
          console.log(data)
          if (data.code === 0) {
            this.list = data.data
          }
        })
      },

      editData: function () {

      },

      deleteData: function () {},

      changeSwitch: function () {}
    }
  }

</script>
<style scoped>
  .a-hover {
    cursor: pointer;
  }

  ._800 {
    font-weight: 800;
  }

</style>
